import useFullScreen from "@/shared/atoms/useFullScreen";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import { useHasSession } from "@/shared/hooks/usePosOrderTableSessionHook";
import IconButton from "../IconButton/IconButton";
import PosCartOrderUser from "./PosCartOrderUser";
import PosCartPosMenu from "./PosCartPosMenu";
import PosCartSessionMenu from "./PosCartSessionMenu";
import PosCartSide from "./PosCartSide";
import NumPad from "./NumPad";
import useIsOrderEditingHook from "@/shared/hooks/useIsOrderEditingHook";
import PosCartBody from "./PosCartBody";
import { cn } from "@/shared/utils/cn";
import PosCartBottom from "./PosCartBottom";
import useDefaultAction from "@/Components/PosMenuAction/useDefaultAction";

interface PosCartProps {
  onClickBack?: () => void;
}

const PosCart = ({ onClickBack }: PosCartProps) => {
  const hasSession = useHasSession();
  const isMobile = useIsMobileHook();
  const [fullScreen] = useFullScreen();
  const isWaiter = useIsWaiter();
  const { isOrderEditing } = useIsOrderEditingHook();
  useDefaultAction();

  return (
    <div
      className={cn(
        "flex w-full flex-[0_0_auto] flex-col overflow-hidden transition-all duration-250",
        isWaiter
          ? "h-full min-h-0"
          : fullScreen
            ? "h-[calc(100vh-3rem)]"
            : "h-[calc(100vh-10rem)]"
      )}
    >
      {!isWaiter && (
        <div className="mb-2  flex shrink-0 items-center justify-between gap-4 md:mb-0">
          <div onClick={onClickBack} className="block xl:hidden">
            <IconButton variants="arrowLeft" />
          </div>
          {isMobile && <PosCartSide />}
        </div>
      )}

      <div
        data-tour="pos-order.cart"
        className="flex min-h-0 flex-1 bg-white flex-col overflow-hidden border border-border rounded-lg"
      >
        <div className="shrink-0">
          {hasSession && !isOrderEditing ? (
            <PosCartSessionMenu />
          ) : (
            <PosCartPosMenu />
          )}
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          <PosCartBody />
        </div>
      </div>
      <div className="relative shrink-0">
        <NumPad show fullWidth callAction canHide />
      </div>
      {!isWaiter && <PosCartOrderUser />}
      <div data-tour="pos-order.checkout" className="relative z-10 shrink-0">
        <PosCartBottom />
      </div>
    </div>
  );
};

export default PosCart;
